import { env } from '@shared/config/env'
import { getBrowserAuthSession } from '@shared/libs/browser-auth-session'

/** Preserve direct-fetch response contracts while restoring browser user sessions. */
export function authenticatedFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  if (typeof window === 'undefined') {
    return fetch(input, init)
  }

  const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined))
  if (!/^Bearer\s+\S+$/i.test(headers.get('Authorization') ?? '')) {
    return fetch(input, init)
  }

  const url = new URL(input instanceof Request ? input.url : String(input), window.location.origin)
  const backendOrigin = new URL(env.NEXT_PUBLIC_PODO_API_URL).origin
  const isBackendRequest = url.origin === backendOrigin
  if (
    (!isBackendRequest && url.origin !== window.location.origin) ||
    /^\/api\/v\d+\/(authentication|oauth|auth)(\/|$)/.test(url.pathname)
  ) {
    return fetch(input, init)
  }

  const session = getBrowserAuthSession()
  return session
    ? session.fetch(
        new Request(input instanceof Request ? input : url, init),
        isBackendRequest ? { backendOrigin } : {},
      )
    : fetch(input, init)
}
